export const blockIconsPlacesGite = (
	<span className='material-symbols-outlined'>gite</span>
);
